/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiShow } from './Show';

export interface LiveScheduleRequest {

    id?: string;

    /**
     * Day of the week
     */
    day?: string;

    /**
     * Scheduled Air Time
     */
    air_time?: string;

    local_air_time?: string;

    air_time_unix?: string;

    /**
     * Title
     */
    title?: string;

    /**
     * Description
     */
    description?: string;

    /**
     * Is Breaking News
     */
    is_breaking_news?: boolean;

    /**
     * Show title on live schedule page
     */
    use_title?: boolean;

    /**
     * Is TYT Plus
     */
    is_premium?: boolean;

    /**
     * Scheduled Duration
     */
    duration?: string;

    /**
     * Show
     */
    show?: ApiShow;

    /**
     * True if this live event is exclusive to TYT apps
     */
    is_app_exclusive?: boolean;

    /**
     * True if the user is entitled to this event
     */
    entitled?: boolean;

}

@Model('LiveSchedule')
export class ApiLiveSchedule extends BaseModel implements LiveScheduleRequest {

    
    
    id: string;

    /**
     * Day of the week
     */
    
    
    day: string;

    /**
     * Scheduled Air Time
     */
    
    
    air_time: string;

    
    
    local_air_time: string;

    
    
    air_time_unix: string;

    /**
     * Title
     */
    
    
    title: string;

    /**
     * Description
     */
    
    
    description: string;

    /**
     * Is Breaking News
     */
    
    
    is_breaking_news: boolean;

    /**
     * Show title on live schedule page
     */
    
    
    use_title: boolean;

    /**
     * Is TYT Plus
     */
    
    
    is_premium: boolean;

    /**
     * Scheduled Duration
     */
    
    
    duration: string;

    /**
     * Show
     */
    @Type('ApiShow')
    @Expand()
    show: ApiShow;

    /**
     * True if this live event is exclusive to TYT apps
     */
    
    
    is_app_exclusive: boolean;

    /**
     * True if the user is entitled to this event
     */
    
    
    entitled: boolean;

}
